/* ################################################################### */
/* FUNCTION (ACCORDION) ############################################## */
/* ################################################################### */
function accordion(speed, ease)
{
	jQuery('.js-accordion_trigger.open', '.js-accordion').each(function()
	{
		jQuery(this).next('.container').css('display', 'block');
	});

	jQuery('.js-accordion_trigger').on('click', function(e)
	{
		e.stopPropagation();

		var jQthis      = jQuery(this);
			idAccordion = jQthis.parents('.js-accordion').attr('id');

		if(!jQthis.hasClass('open'))
		{
			jQuery('.js-accordion_trigger.open', '#' + idAccordion)
				.removeClass('open')
				.next('.container').slideUp(speed, ease);

			jQthis
				.addClass('open')
				.next('.container').slideDown(speed, ease);
		}
		else
		{
			jQthis
				.removeClass('open')
				.next('.container').slideUp(speed, ease);
		}
	});
}
